import index from '@/views/zhibo/index.vue'

export default[
  {
    path: '/zhibo',
    name: 'zhiboIndex',
    meta: {
      title: '首页',
      NeedLogin: false,
      keepAlive: true
    },
    component: index
  }
]
